// El Pixel de Meta vive oculto en el GTM del cliente (protección de datos).
// Aquí solo empujamos el evento al dataLayer cuando el envío se confirma;
// GTM lo mapea al evento Lead de Meta.

export function initPixel() {
  window.dataLayer = window.dataLayer || [];
}

export function trackLead() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "Lead" });
}

export function trackShareCard(formato) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "DescargaTarjeta", formato });
}
